import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';
import { Mail, ArrowLeft } from 'lucide-react';

export default function RecuperarSenha() {
  const [email, setEmail] = useState('');
  const [cpf, setCpf] = useState('');
  const [tipo, setTipo] = useState('email');
  const [enviado, setEnviado] = useState(false);
  const [enviando, setEnviando] = useState(false);

  const formatCPF = (v) => v.replace(/\D/g, '').slice(0, 11)
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})$/, '$1-$2');

  const enviar = async (e) => {
    e.preventDefault();
    setEnviando(true);
    try {
      await axios.post('/api/recuperar-senha/solicitar', tipo === 'email' ? { email } : { cpf });
      setEnviado(true);
      toast.success('E-mail enviado com sucesso!');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Erro ao enviar e-mail');
    } finally { setEnviando(false); }
  };

  return (
    <div className="login-page">
      <div className="login-box">
        <div className="login-logo">
          <div style={{ fontSize: '3rem', marginBottom: 8 }}>📧</div>
          <h1>Câmara Digital</h1>
          <p>Recuperação de Senha</p>
        </div>

        {!enviado ? (
          <>
            <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
              <button type="button" className={`btn btn-sm ${tipo === 'email' ? 'btn-primary' : 'btn-secondary'}`} style={{ flex: 1, justifyContent: 'center' }} onClick={() => setTipo('email')}>
                📧 Por E-mail
              </button>
              <button type="button" className={`btn btn-sm ${tipo === 'cpf' ? 'btn-primary' : 'btn-secondary'}`} style={{ flex: 1, justifyContent: 'center' }} onClick={() => setTipo('cpf')}>
                🪪 Por CPF
              </button>
            </div>

            <form onSubmit={enviar}>
              {tipo === 'email' ? (
                <div className="form-group">
                  <label className="form-label"><Mail size={12} style={{ display: 'inline', marginRight: 4 }} />E-mail cadastrado</label>
                  <input className="form-input" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="seu@email.com" required />
                </div>
              ) : (
                <div className="form-group">
                  <label className="form-label">CPF do Vereador</label>
                  <input className="form-input" type="text" value={cpf} onChange={e => setCpf(formatCPF(e.target.value))} placeholder="000.000.000-00" required />
                </div>
              )}
              <button className="btn btn-primary" style={{ width: '100%', justifyContent: 'center', marginTop: 8 }} type="submit" disabled={enviando}>
                {enviando ? 'Enviando...' : '📧 Enviar Link de Recuperação'}
              </button>
            </form>
          </>
        ) : (
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <div style={{ fontSize: '3rem', marginBottom: 12 }}>📬</div>
            <h3 style={{ color: 'var(--verde)', marginBottom: 8 }}>E-mail enviado!</h3>
            <p style={{ color: 'var(--texto-suave)', fontSize: '0.875rem', marginBottom: 20 }}>
              Verifique sua caixa de entrada e clique no link para redefinir sua senha. O link expira em <strong>1 hora</strong>.
            </p>
          </div>
        )}

        <p style={{ textAlign: 'center', marginTop: 20, fontSize: '0.85rem', color: 'var(--texto-suave)' }}>
          <Link to="/login/admin" style={{ color: 'var(--verde)', fontWeight: 600, display: 'inline-flex', alignItems: 'center', gap: 4 }}>
            <ArrowLeft size={13} /> Voltar ao login
          </Link>
        </p>
      </div>
    </div>
  );
}